import { useAuth } from "@clerk/clerk-react";
import QueryString from "qs";
import { useState } from "react";
import useSWR from "swr";
import { DeviceFilterType, TDevice } from "../types/Devices";
import { DefaultFilterType } from "../types/PageFilterTypes";
import { fetcher } from "../utils/axios";

const useAdminDevices = (
  account_id: string | null,
  defaultFilter: DefaultFilterType & DeviceFilterType = {
    sort: "name|asc",
    limit: 20,
  }
) => {
  const { getToken } = useAuth();
  const [filter, setFilter] = useState(defaultFilter);

  const { data, error, mutate } = useSWR(
    account_id
      ? [`/accounts/${account_id}/devices`, `?${QueryString.stringify(filter)}`]
      : null,
    async (args) => {
      const token = await getToken();
      const path = `${args[0]}${args[1] || ""}`;

      return fetcher(path, token);
    },
    {
      revalidateOnFocus: false,
    }
  );

  const updateFilter = (newFilter: DefaultFilterType & DeviceFilterType) => {
    setFilter((prev) => ({ ...prev, ...newFilter }));
  };

  // const adoptDevice = async (deviceId: string) => {
  //   const token = await getToken();
  //   await apiPost(`/devices/${deviceId.toLowerCase()}/adopt`, {}, token);

  //   mutate();
  // };

  // const updateDeviceById = async (deviceId: string, data: Partial<TDevice>) => {
  //   const token = await getToken();
  //   console.log("data", data);
  //   await apiPatch(`/devices/${deviceId.toLowerCase()}`, data, token);

  //   mutate();
  // };

  return {
    devices: (data as TDevice[]) || [],
    isLoading: !error && !data,
    isError: error,
    // adoptDevice,
    // updateDeviceById,
    mutate,
    filters: filter,
    updateFilter,
  };
};

export { useAdminDevices };
